import domain from "@/environment";
import axios from "axios";
const state = {
  entiteExterne: null,
  entitesExternes: [],
  entiteExterneRows: 0,
  entiteExterneLoding:false,
};

const getters = {
  getLoadingEntiteExterne: (state) => state.entiteExterneLoding,
  getEntiteExterne: (state) => state.entiteExterne,
  getAllEntitesExternes: (state) => state.entitesExternes,
  getTotalRowEntiteExterne: (state) => state.entiteExterneRows,
  getPartenaireEntitesExternes: (state) => {
   
    return state.entitesExternes.filter(
      (entite) => entite.type === 'oblige'
    );
  },

  getMondataireEntitesExternes: (state) => {
    return state.entitesExternes.filter(
      (entite) => 
        entite.type === 'mandataire' || 
        entite.type === 'delegataire'
    );
  }
  
};

const mutations = {
  DO_NOTHING() {},
  SET_ENTITE_EXTERNE_LODING(state, payload) {
    state.entiteExterneLoding = payload || false;
  },
  SET_ENTITE_EXTERNE(state, payload) {
    state.entiteExterne = payload ? payload : null;
  },
  PUSH_ENTITE_EXTERNE(state, payload) {
    state.entitesExternes.push(payload);
  },
 
  UPDATE_ENTITE_EXTERNE(state, payload) {

    for (let index = 0; index < state.entitesExternes.length; index++) {
      if (state.entitesExternes[index].id === payload.id) {
        state.entitesExternes.splice(index, 1, payload);
        break;
      }
    }
  },
  DELETE_ENTITE_EXTERNE(state, payload) {
    state.entitesExternes = state.entitesExternes.filter(
      (item) => item.id !== payload.id
    );
  },

  UPDATE_ENTITE_EXTERNE_ROW(state, payload) {

    state.entiteExterneRows = payload ? payload : 0;
  },
  SET_ENTITES_EXTERNES(state, payload) {
    state.entitesExternes = payload ? payload : [];
  },
  
};

const actions = {
  async allEntitesExternes({ commit }, payload) {
    commit("SET_ENTITE_EXTERNE_LODING",true);

    const params = {
      page: payload.page,
      per_page: payload.per_page,
    };
    
    // Ajouter les paramètres optionnels seulement s'ils sont définis
    if (payload.entreprise_id != null) {
      params.entreprise_id = payload.entreprise_id;
    }
    if (payload.nom != null) {
      params.nom = payload.nom;
    }
    if (payload.type != null) {
      params.type = payload.type;
    }
    
    try {
      const response = await axios.get(domain + "/entites-externes", {
        headers: {
          Authorization: `Bearer ` + this.state.token,
        },
        params,
      });
    
      if (response.data.data.data) {
        commit("UPDATE_ENTITE_EXTERNE_ROW", response.data.data.total);
        commit("SET_ENTITES_EXTERNES", response.data.data.data); 
      } else {
     
        commit("SET_ENTITES_EXTERNES", []);
      }
      commit("SET_ENTITE_EXTERNE_LODING",false);
      return true;
    } catch (error) {
     
      commit("SET_ENTITE_EXTERNE_LODING",false);
      throw error.response ? error.response.data.message : error.message;
    }
  },
  async entiteExterne({ commit }, payload) {
    commit("DO_NOTHING");
    try {
      const response = await axios.get(
        domain + `/entites-externes/` + payload,
        {
          headers: {
            Authorization: `Bearer ` + this.state.token,
          },
        }
      );
      commit("SET_ENTITE_EXTERNE", response.data.data);
      return response.data;
    } catch (error) {
      throw error.response.data.message;
    }
  }
,
async editEntiteExterne({ commit }, payload) {
  try {
      // Extract ID from payload (handle both FormData and plain object)
      let id;
      if (payload instanceof FormData) {
        id = payload.get('id');
      } else {
        id = payload.id;
      }
      
      if (!id) {
        throw new Error("ID is required for editing entite externe");
      }
      
      const headers = {
          Authorization: `Bearer ` + this.state.token,
      };
      
      // Add Content-Type header if payload is FormData
      if (payload instanceof FormData) {
        headers['Content-Type'] = 'multipart/form-data';
      }
      
      const response = await axios.put(
          domain + `/entites-externes/` + id,
          payload,
          {
              headers: headers,
          }
      );

      commit("UPDATE_ENTITE_EXTERNE", response.data.data);
      return response.data.data;
      
  } catch (error) {
      throw error.response && error.response.data ? error.response.data.message : error.message;
  }
},
  async storeEntiteExterne({ commit }, payload) {
    try {
      const headers = {
        Authorization: `Bearer ` + this.state.token,
      };
      
      // Add Content-Type header if payload is FormData
      if (payload instanceof FormData) {
        headers['Content-Type'] = 'multipart/form-data';
      }
      
      const response = await axios.post(
        domain + `/entites-externes`,
        payload,
        {
          headers: headers,
        }
      );

      commit("PUSH_ENTITE_EXTERNE", response.data.data);
      commit("UPDATE_ENTITE_EXTERNE_ROW", state.entiteExterneRows + 1);
      return response.data.data; // Return the created entity data
    } catch (error) {
      throw error.response && error.response.data ? error.response.data.message : error.message;
    }
  },
  async deleteEntiteExterne({ commit }, payload) {
    
    commit("SET_ENTITE_EXTERNE_LODING",true);
    try {
      await axios.delete(domain + `/entites-externes/` + payload.id, {
        headers: {
          Authorization: `Bearer ` + this.state.token,
        },
      });
      commit("DELETE_ENTITE_EXTERNE", payload);
      commit("UPDATE_ENTITE_EXTERNE_ROW", state.entiteExterneRows - 1);
      
      commit("SET_ENTITE_EXTERNE_LODING",false);
      return true;
    } catch (error) {
      throw error.response.data.message;
    }
  },
};

export default { state, mutations, getters, actions };
